import { RouterRootState } from "connected-react-router";
import { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import CardFormatTab from "../../../containers/card-formats-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useTabCount } from "../../../hooks/useCategoryTab";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { Filter } from "../../../models/Filter";
import { showError } from "../../../services/utilities/ServiceError";
import { getListOfSiteIdsFromFilter } from "../../../utilities/tabUtils";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const CardFormats: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname)); 
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.cardFormats),
                    heading: translate.byKey(TranslationKeys.cardFormats),
                    value: "",
                    id: 0,
                    count: 0,
                },
            ]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [<CardFormatTab setBusy={setBusy} categories={categories} setCategories={setCategories} onFilterChange={onFilterChange} />];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const { updateTabCount } = useTabCount({
        tableName: "TruncationFormat",
        categories,
        setCategories,
    });

    const onFilterChange = (filters: Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilter(filters);
        updateTabCount(siteIds);
    }

    return (
        <>
            <ActivityFrame
                busy={busy}
                className="flex flex-grow overflow-y-hidden">
                <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            {
                                value: "/access-control/configuration",
                                displayName: translate.byKey(TranslationKeys.configuration),
                                disableClick: true
                            },
                            {
                                value: "/access-control/configuration/card-formats",
                                displayName: translate.byKey(TranslationKeys.cardFormats),
                            },
                        ]}
                        onClick={(item) => history.push(item.value)} />
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                        <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                            <div className="flex flex-row mt-2 justify-end button-cluster">
                               <Restricted to={`add.${routeName}.element`}>                                
                                    <Link
                                        to={{ pathname: "/access-control/configuration/card-format/" }}>
                                        <button className="flex rounded-lg bg-lime text-white p-2 shadow-lg" id='addFormatBtn'>
                                            <img
                                                src={plusIcon}
                                                className="px-2 w-8 py-1"
                                                alt="" />
                                            <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                        </button>
                                    </Link>
                                </Restricted>
                            </div>
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default CardFormats;
